<ng-container *ngIf="isMenuSet">
    <nb-menu 
    [items]="items" 
    class="menu-items" 
    #headerMenu 
    autoCollapse="true" 
    tag="main-menu"
    kwRemoveChildren
    ></nb-menu>
</ng-container>
<div [nbPopover]="subnavComp" style="display:none" [nbPopoverContext]="subMenuItems" nbPopoverTrigger="noop"></div>
<!-- <div style="display:none" [nbContextMenu]="subMenuItems" nbContextMenuTrigger="noop"></div> -->

<!-- <button *ngIf="isSubMenuSet" style="display:none" class="menu-target" nbButton [nbContextMenu]="subMenuItems" nbContextMenuTrigger="noop"></button> -->


<!-- <ng-template #subMenus>
    <div class="sub-menus">
        <nb-card>
            <nb-menu [items]="subMenuItems" class="menu-items" tag="sub-menu"></nb-menu>
        </nb-card>
    </div>
</ng-template> -->

